var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.099 25.9755C117.099 25.9755 117.501 23.0805 117.521 21.6525C117.542 20.2245 116.99 19.047 116.99 19.047L115.407 17.9565L113.007 18.0105L111.389 18.246L102.453 18.441L98.7676 17.139H91.0756L87.3661 15.819L85.5961 15.69L84.5296 15.2295L68.4361 15.5025V16.9215L67.7821 17.5215H66.5821L65.9821 18.885H47.2306L45.5791 19.212L37.0096 19.1295L35.8981 19.689L34.8316 19.212H33.4126L31.9936 20.8425H30.4111L30.0841 20.2485H27.6841L27.4246 20.8485L20.1901 20.841L19.6651 20.247H18.0496L17.4841 20.841L12.3556 20.9025L10.7731 21.6525L3.08105 21.4485V25.212H11.1421L13.3381 25.7025L17.5381 25.6485C17.5381 25.6485 17.8111 26.4675 17.8111 26.685C17.8111 26.9025 15.9556 26.7945 15.9556 26.7945V29.25H32.3221L32.8861 31.4595L33.6031 32.112C33.6031 32.112 33.8446 34.212 33.8491 34.323C33.8536 34.434 34.3321 35.985 34.3321 35.985L35.8126 34.1055L63.5266 33.942L71.7091 31.65C71.7091 31.65 71.9116 34.761 71.9221 34.923C71.9326 35.0865 72.4726 36.0885 72.4726 36.0885L72.5266 37.923L73.2766 39.198C73.2766 39.198 73.1551 40.6605 73.1116 42.519C73.0681 44.379 75.3091 44.796 75.3091 44.796C75.3091 44.796 80.6161 45.423 81.8551 45.5595C83.0941 45.696 83.8786 45.6 84.9106 45.2865C85.9426 44.973 87.1501 43.5165 87.1501 43.5165L88.3306 36.939C88.3306 36.939 88.4701 36.1365 88.8901 34.9485C89.3101 33.7605 91.7746 33.147 91.7746 33.147C91.7746 33.147 93.1471 32.793 93.8701 33.0525C94.5931 33.312 95.3371 35.1345 95.8201 36.087C96.3031 37.038 97.0756 39.2865 97.0756 39.2865L98.4391 40.5405L103.841 41.031L104.927 40.062L107.246 37.641C107.246 37.641 111.699 35.85 113.096 35.151C114.492 34.452 117.48 32.6565 117.48 32.6565V31.041L116.99 30.0135L117.099 25.9755V25.9755ZM68.9146 30.7755H57.5806L56.0251 30.432C56.0251 30.432 57.5386 28.893 59.3386 28.689C61.1386 28.485 62.4691 28.485 62.4691 28.485L63.6346 28.7715L68.9131 28.689V30.7755H68.9146ZM91.6231 31.9755C89.9866 32.358 88.0831 32.3505 88.0831 32.3505L88.3591 29.0145L89.4121 28.116H91.4581C91.4581 28.116 91.6216 29.5755 91.1041 30.285L90.5851 30.9945C90.5851 30.9945 92.2216 30.798 92.3581 30.432C92.4946 30.066 93.6121 30.432 93.6121 30.432C93.6121 30.432 93.2581 31.5945 91.6216 31.9755H91.6231ZM107.363 34.6485C106.463 35.358 102.234 37.404 100.053 34.812C97.8706 32.22 94.8706 28.974 97.6801 27.6375L107.282 27.501C107.282 27.501 109.764 27.177 109.737 30.012C109.71 32.847 108.264 33.939 107.364 34.647L107.363 34.6485Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3295 22.5526L74.955 44.6865",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8583 22.1011L83.5153 45.6286",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3629 21.8806L78.1199 23.9026L78.5714 24.4336L82.4579 24.8026L84.0539 23.6971L84.2999 21.9151",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1578 27.4921H84.2998L83.5153 34.3351L84.6148 34.5916",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3378 43.8211L85.6908 43.2136",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6874 41.7825L85.6909 41.4135",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0135 38.6311L86.1805 38.4271",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5975 34.5916H86.55",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8583 30.2341L86.7538 30.5851",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1805 26.793L87.1765 27.285",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3065 24.5296L87.421 25.1566",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9653 25.1056L73.2793 39.1966",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1412 42.1096L80.2077 42.5191",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.055 36.0871C102.055 36.0871 103.119 37.1581 101.769 38.1406C101.403 38.4076 100.918 38.6071 100.407 38.7571C99.0355 39.1576 97.4725 39.1981 97.4725 39.1981",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.408 38.7571L103.857 39.4921C103.857 39.4921 106.107 37.1041 108.316 36.0886C110.526 35.0731 114.085 33.1906 114.085 33.1906V31.6501C114.085 31.6501 111.549 29.7541 111.589 29.6311C111.63 29.5081 111.549 28.3216 111.549 28.3216L111.999 27.8716V25.9726",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2859 29.7946H94.6089C94.6089 29.7946 94.8129 28.3216 91.4589 28.1176",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.215 25.7026C100.255 25.5796 101.934 24.1066 101.934 24.1066H111.303L112.899 21.8611H115.735",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.584 20.5065H115.735",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1229 19.1281V20.2471",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4725 19.1281V20.2471",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8241 19.1281V20.2471",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9863 23.6971L93.4904 25.6141",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7959 23.7811L88.6229 26.1931",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6833 19.1281V21.8806L75.4603 22.5526",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0288 21.8596C40.144 21.8596 40.2373 21.7662 40.2373 21.6511C40.2373 21.5359 40.144 21.4426 40.0288 21.4426C39.9137 21.4426 39.8203 21.5359 39.8203 21.6511C39.8203 21.7662 39.9137 21.8596 40.0288 21.8596Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4993 21.8596C42.6144 21.8596 42.7078 21.7662 42.7078 21.6511C42.7078 21.5359 42.6144 21.4426 42.4993 21.4426C42.3841 21.4426 42.2908 21.5359 42.2908 21.6511C42.2908 21.7662 42.3841 21.8596 42.4993 21.8596Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9699 21.8596C45.085 21.8596 45.1784 21.7662 45.1784 21.6511C45.1784 21.5359 45.085 21.4426 44.9699 21.4426C44.8547 21.4426 44.7614 21.5359 44.7614 21.6511C44.7614 21.7662 44.8547 21.8596 44.9699 21.8596Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4408 21.8596C47.5559 21.8596 47.6493 21.7662 47.6493 21.6511C47.6493 21.5359 47.5559 21.4426 47.4408 21.4426C47.3256 21.4426 47.2323 21.5359 47.2323 21.6511C47.2323 21.7662 47.3256 21.8596 47.4408 21.8596Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9105 21.8596C50.0257 21.8596 50.119 21.7662 50.119 21.6511C50.119 21.5359 50.0257 21.4426 49.9105 21.4426C49.7954 21.4426 49.702 21.5359 49.702 21.6511C49.702 21.7662 49.7954 21.8596 49.9105 21.8596Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3815 21.8596C52.4966 21.8596 52.59 21.7662 52.59 21.6511C52.59 21.5359 52.4966 21.4426 52.3815 21.4426C52.2663 21.4426 52.173 21.5359 52.173 21.6511C52.173 21.7662 52.2663 21.8596 52.3815 21.8596Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8519 21.8596C54.9671 21.8596 55.0604 21.7662 55.0604 21.6511C55.0604 21.5359 54.9671 21.4426 54.8519 21.4426C54.7368 21.4426 54.6434 21.5359 54.6434 21.6511C54.6434 21.7662 54.7368 21.8596 54.8519 21.8596Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3239 21.8596C57.439 21.8596 57.5324 21.7662 57.5324 21.6511C57.5324 21.5359 57.439 21.4426 57.3239 21.4426C57.2087 21.4426 57.1154 21.5359 57.1154 21.6511C57.1154 21.7662 57.2087 21.8596 57.3239 21.8596Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2631 23.3281C41.3782 23.3281 41.4716 23.2347 41.4716 23.1196C41.4716 23.0044 41.3782 22.9111 41.2631 22.9111C41.1479 22.9111 41.0546 23.0044 41.0546 23.1196C41.0546 23.2347 41.1479 23.3281 41.2631 23.3281Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7339 23.3281C43.849 23.3281 43.9424 23.2347 43.9424 23.1196C43.9424 23.0044 43.849 22.9111 43.7339 22.9111C43.6187 22.9111 43.5254 23.0044 43.5254 23.1196C43.5254 23.2347 43.6187 23.3281 43.7339 23.3281Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2043 23.3281C46.3195 23.3281 46.4128 23.2347 46.4128 23.1196C46.4128 23.0044 46.3195 22.9111 46.2043 22.9111C46.0892 22.9111 45.9958 23.0044 45.9958 23.1196C45.9958 23.2347 46.0892 23.3281 46.2043 23.3281Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6762 23.3281C48.7913 23.3281 48.8847 23.2347 48.8847 23.1196C48.8847 23.0044 48.7913 22.9111 48.6762 22.9111C48.561 22.9111 48.4677 23.0044 48.4677 23.1196C48.4677 23.2347 48.561 23.3281 48.6762 23.3281Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1469 23.3281C51.262 23.3281 51.3554 23.2347 51.3554 23.1196C51.3554 23.0044 51.262 22.9111 51.1469 22.9111C51.0317 22.9111 50.9384 23.0044 50.9384 23.1196C50.9384 23.2347 51.0317 23.3281 51.1469 23.3281Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6176 23.3281C53.7327 23.3281 53.8261 23.2347 53.8261 23.1196C53.8261 23.0044 53.7327 22.9111 53.6176 22.9111C53.5024 22.9111 53.4091 23.0044 53.4091 23.1196C53.4091 23.2347 53.5024 23.3281 53.6176 23.3281Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0873 23.3281C56.2024 23.3281 56.2958 23.2347 56.2958 23.1196C56.2958 23.0044 56.2024 22.9111 56.0873 22.9111C55.9721 22.9111 55.8788 23.0044 55.8788 23.1196C55.8788 23.2347 55.9721 23.3281 56.0873 23.3281Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1854 22.5526L37.8324 21.4426V19.2106",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6454 21.4426H61.1819L61.9589 21.8611H74.6834",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8658 21.8806V23.1196H66.2953L65.3548 23.6971H61.8778V21.8611",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9639 26.1931V32.6581H47.6504V29.0416H40.0289V27.7681H61.0994V26.6851H38.9639",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0194 29.6296H47.6504",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1824 21.6511V22.7791V24.9721",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0489 22.3681H11.3124",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1913 22.3681H27.5563",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0489 24.1065H11.3124",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1913 24.1066H27.5563",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6612 26.439H33.9827C33.6157 26.439 33.3182 26.7365 33.3182 27.1035V27.105C33.3182 27.472 33.6157 27.7695 33.9827 27.7695H35.6612C36.0282 27.7695 36.3257 27.472 36.3257 27.105V27.1035C36.3257 26.7365 36.0282 26.439 35.6612 26.439Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0289 31.0935C40.1026 31.0935 40.1624 31.0338 40.1624 30.96C40.1624 30.8863 40.1026 30.8265 40.0289 30.8265C39.9552 30.8265 39.8954 30.8863 39.8954 30.96C39.8954 31.0338 39.9552 31.0935 40.0289 31.0935Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0292 30.96H46.2047",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8964 18.7666V17.1376H73.5174L74.8464 16.1281H83.9499L84.4824 17.0491",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08289 21.447H11.1019L12.3559 20.901H17.9209V20.247H19.8844V20.847H27.6859V20.247H30.0859V20.847H32.3224V20.247L33.4129 19.2105H35.3764L36.0304 19.8105L36.5764 19.2105H45.9094C45.9094 19.2105 46.1224 18.8835 47.3224 18.8835H65.9794V18.3375L66.5794 18.12V17.52H67.7794L68.4334 16.92V15.2295H84.5269L85.8904 15.819H87.3634L91.0729 17.139H98.7649L103.074 18.339H111.149L112.131 17.9565H115.404L116.987 19.047C116.987 19.047 117.369 19.701 117.477 20.9025C117.587 22.1025 117.477 25.2675 117.095 25.9755L116.985 30.0135L117.476 30.7215V32.4675L116.657 33.177C116.657 33.177 112.674 35.577 109.128 36.996L106.892 37.9785C106.892 37.9785 105.092 39.561 104.709 40.434L103.836 41.034C103.836 41.034 99.4714 40.3245 98.2714 40.2705L97.0714 39.288C97.0714 39.288 97.0174 38.9055 96.8539 38.361C96.6904 37.815 94.9444 34.215 94.5079 33.7245C94.0714 33.234 93.6889 32.742 93.1444 32.7975C92.5984 32.8515 90.4714 33.507 89.6524 34.0515C88.8334 34.5975 88.5064 35.7975 88.3984 36.507C88.2904 37.2165 87.9619 39.0705 87.9619 39.0705L87.3079 43.107C87.3079 43.107 87.3079 43.569 86.4889 44.211C85.6699 44.853 84.9064 45.2895 84.9064 45.2895C84.9064 45.2895 84.4159 45.8355 81.8509 45.5625C79.2874 45.2895 75.3049 44.799 75.3049 44.799C75.3049 44.799 73.5589 44.3625 73.2319 43.4355C72.9049 42.5085 73.2859 39.0705 73.2859 39.0705L72.5224 37.9245L72.6859 36.942L71.9764 35.8515L71.7034 31.6515L63.5209 33.9435L35.8069 34.107L35.7529 34.8165H34.8259V36.0165L33.8989 35.9625L33.7894 32.6895L33.1354 32.199C33.1354 32.199 33.0814 29.307 32.2084 29.253C31.3354 29.199 27.5164 29.253 27.5164 29.253H15.9574V26.7975H17.8129V25.6515H12.6844L11.1439 25.215H3.08289V21.4515V21.447Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9209 20.901V29.2485",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8846 20.8469V29.0984",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8846 26.6849H26.7321L27.4266 25.5389H19.8846V26.6849Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6854 20.8469V26.4389H30.0449V20.8469",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3224 20.847V26.112C32.3224 26.112 33.1129 25.5795 33.9724 25.539L34.8319 25.4985V20.5065L35.3779 19.2105L34.8319 20.5065H32.3224",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8319 25.497C34.8319 25.497 37.1239 25.2105 37.4509 26.6835C37.7779 28.1565 37.2049 29.016 35.9374 29.4255",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M35.691 34.104V28.812H33.8505V33.1455",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3221 26.1121C32.3221 26.1121 31.5181 28.8121 33.6046 29.4256",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0331 19.8105V25.293",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0253 25.9725H56.8448L57.7853 25.539H67.1963L68.0153 25.9725H73.8668C73.8668 25.9725 74.9108 25.887 74.9663 25.1055C75.0653 23.7345 75.4628 22.5525 75.4628 22.5525C75.4628 22.5525 75.7703 22.041 77.0993 21.939C79.3568 21.765 85.1603 21.939 85.1603 21.939C85.1603 21.939 86.2643 21.939 86.7563 22.962L87.2468 23.985L87.8603 24.804C87.8603 24.804 88.2278 25.5405 88.4333 26.85C88.6373 28.1595 86.9198 43.8225 86.9198 43.8225",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3594 29.0145L89.4124 28.116H91.4584C91.4584 28.116 91.6219 29.5755 91.1044 30.285L90.5854 30.9945C90.5854 30.9945 92.2219 30.798 92.3584 30.432C92.4949 30.066 93.6124 30.432 93.6124 30.432C93.6124 30.432 93.2584 31.5945 91.6219 31.9755C89.9854 32.358 88.0819 32.3505 88.0819 32.3505L88.3579 29.0145H88.3594Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6786 27.639L107.28 27.5025C107.28 27.5025 109.763 27.1785 109.736 30.0135C109.709 32.8485 108.263 33.9405 107.363 34.6485C106.463 35.3565 102.234 37.404 100.053 34.812C97.8706 32.22 94.8706 28.974 97.6801 27.6375L97.6786 27.639Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9149 28.689V30.7755H57.5809L56.0254 30.432C56.0254 30.432 57.5389 28.893 59.3389 28.689C61.1389 28.485 62.4694 28.485 62.4694 28.485L63.6349 28.7715L68.9134 28.689H68.9149Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8665 25.9725L72.6935 36.9405",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9435 26.193V31.6485",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0614 25.9724V32.1104",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4139 28.116L93.6139 25.539H97.4329L98.1154 25.9725H111.59C111.59 25.9725 113.009 26.085 113.445 25.539C113.882 24.993 113.336 24.12 115.737 24.12V18.4725",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9824 18.8835H115.736",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0774 17.1375H77.1124L75.9559 18.8835",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M86.915 23.295L87.4505 21.57C87.4505 21.57 87.818 20.5065 89.7425 20.5065H100.053L104.268 21.9V22.92H99.8495C99.8495 22.92 98.336 22.797 97.9265 23.697H89.4155C89.4155 23.697 88.802 23.3295 89.048 22.92H86.756",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaw);
export default __webpack_public_path__ + "static/media/SAW.4a7c6d074d9cebe9f2e01049a7f920db.svg";
export { ForwardRef as ReactComponent };